(function () {
  var root = document.getElementById('media-gallery-root');
  var enableNavigation = root && root.dataset.enableNavigation === 'true';

  function initMediaGalleryProductVideos() {
    if (!root) return;
    root.querySelectorAll('.media-gallery-video-wrap').forEach(function (wrap) {
      if (wrap.dataset.galleryVideoBound === 'true') return;
      var video = wrap.querySelector('video.media-gallery__video-el') || wrap.querySelector('video');
      if (!video) return;
      wrap.dataset.galleryVideoBound = 'true';
      video.setAttribute('playsinline', '');
      var btnPlay = wrap.querySelector('.media-gallery-video-play');
      var btnMute = wrap.querySelector('.media-gallery-video-mute');
      if (!btnPlay || !btnMute) return;
      var iconPause = btnPlay.querySelector('.media-gallery-video-play__icon-pause');
      var iconPlay = btnPlay.querySelector('.media-gallery-video-play__icon-play');
      var iconMuted = btnMute.querySelector('.media-gallery-video-mute__icon-muted');
      var iconUnmuted = btnMute.querySelector('.media-gallery-video-mute__icon-unmuted');

      function syncPlayUi() {
        var playing = !video.paused;
        btnPlay.setAttribute('data-playing', playing ? 'true' : 'false');
        btnPlay.setAttribute('aria-pressed', playing ? 'true' : 'false');
        btnPlay.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        if (iconPause && iconPlay) {
          iconPause.classList.toggle('hidden', !playing);
          iconPlay.classList.toggle('hidden', playing);
        }
      }
      function syncMuteUi() {
        var muted = video.muted;
        btnMute.setAttribute('data-muted', muted ? 'true' : 'false');
        btnMute.setAttribute('aria-pressed', muted ? 'true' : 'false');
        btnMute.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
        if (iconMuted && iconUnmuted) {
          iconMuted.classList.toggle('hidden', !muted);
          iconUnmuted.classList.toggle('hidden', muted);
        }
      }

      btnPlay.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
      btnMute.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        video.muted = !video.muted;
      });
      video.addEventListener('play', syncPlayUi);
      video.addEventListener('pause', syncPlayUi);
      video.addEventListener('volumechange', syncMuteUi);
      syncPlayUi();
      syncMuteUi();
    });
  }

  initMediaGalleryProductVideos();

  function moveNode(node, newParent, beforeNode) {
    if (node && newParent && node.parentNode !== newParent) {
      newParent.insertBefore(node, beforeNode || null);
    }
  }

  function waitForSwiper(cb) {
    if (window.Swiper) {
      cb();
    } else {
      setTimeout(function () {
        waitForSwiper(cb);
      }, 50);
    }
  }

  waitForSwiper(function () {
    var mainSwiper;
    var thumbsSwiper;
    var isModalOpen = false;
    var modal = document.getElementById('media-gallery-modal');
    var modalAnchor = document.getElementById('media-gallery-modal-swiper-anchor');
    var inlineAnchor = document.getElementById('media-gallery-swiper-inline');
    var mainSwiperEl = document.querySelector('.media-gallery-main');
    var thumbsSwiperEl = document.querySelector('.media-gallery-thumbs');
    var returnFocus;
    var resizeFrame = 0;
    var modalFrame = 0;
    var focusFrame = 0;
    var bodyOverflowY = '';
    var bodyOverflowPriority = '';
    var bodyLockApplied = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var inlineReservation = null;

    function reserveInlineGallerySpace(height) {
      if (window.innerWidth >= 990 || mainSwiperEl.parentNode !== inlineAnchor || inlineReservation) return;
      // Read before changing carousel styles. Keep the product page in place
      // while the same accessible carousel is moved into its lightbox.
      if (!height) return;
      inlineReservation = {
        value: inlineAnchor.style.getPropertyValue('height'),
        priority: inlineAnchor.style.getPropertyPriority('height'),
        reserved: height + 'px'
      };
      inlineAnchor.style.setProperty('height', inlineReservation.reserved, inlineReservation.priority);
      inlineReservation.reserved = inlineAnchor.style.getPropertyValue('height');
    }

    function releaseInlineGallerySpace() {
      if (!inlineReservation) return;
      if (inlineAnchor.style.getPropertyValue('height') === inlineReservation.reserved &&
          inlineAnchor.style.getPropertyPriority('height') === inlineReservation.priority) {
        if (inlineReservation.value) inlineAnchor.style.setProperty('height', inlineReservation.value, inlineReservation.priority);
        else inlineAnchor.style.removeProperty('height');
      }
      inlineReservation = null;
    }

    var mediaCount = mainSwiperEl ? mainSwiperEl.querySelector('.swiper-wrapper').children.length : 0;

    if (!modal || !modalAnchor || !inlineAnchor || !mainSwiperEl) return;
    if (!mainSwiperEl.style.contain) mainSwiperEl.style.contain = 'layout style';
    if (thumbsSwiperEl && !thumbsSwiperEl.style.contain) thumbsSwiperEl.style.contain = 'layout style';
    var mainWrapper = mainSwiperEl.querySelector('.swiper-wrapper');
    var originalSlides = Array.from(mainWrapper.children);
    var bufferedGallery = mediaCount > 1 && mediaCount < 4 && originalSlides.every(function (slide) {
      return slide.querySelector('img') && !slide.querySelector('video, iframe, model-viewer');
    });
    // Short galleries need spare offscreen slides so a visible photo is never
    // recycled during a drag. Reuse image URLs and lazy-load the buffer copies.
    if (bufferedGallery) {
      var bufferedCount = Math.ceil(8 / mediaCount) * mediaCount;
      for (var copyIndex = mediaCount; copyIndex < bufferedCount; copyIndex++) {
        var copy = originalSlides[copyIndex % mediaCount].cloneNode(true);
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
        copy.querySelectorAll('img').forEach(function (image) {
          image.loading = 'lazy';
          image.removeAttribute('fetchpriority');
        });
        mainWrapper.appendChild(copy);
      }
    }
    var carouselCount = mainWrapper.children.length;

    if (thumbsSwiperEl) {
      moveNode(thumbsSwiperEl, modalAnchor);
      thumbsSwiperEl.style.display = '';
    }
    // Desktop uses the grid inline. Keep its carousel in the lightbox so
    // opening/closing does not detach and lay out the same slides again.
    if (window.innerWidth >= 990) moveNode(mainSwiperEl, modalAnchor, thumbsSwiperEl);

    function scheduleModalChange(callback) {
      if (modalFrame) cancelAnimationFrame(modalFrame);
      if (focusFrame) cancelAnimationFrame(focusFrame);
      // Let the original click reach document-level analytics before changing
      // layout. Do not stop propagation or synthesize a second click.
      modalFrame = requestAnimationFrame(function () {
        modalFrame = 0;
        callback();
      });
    }

    function restoreFocusAfterLayout(element, expectedOpen) {
      focusFrame = requestAnimationFrame(function () {
        focusFrame = 0;
        if (isModalOpen === expectedOpen && element && element.isConnected) {
          element.focus({ preventScroll: true });
        }
      });
    }

    function updateGalleryLayout(force) {
      var mainWidth = mainSwiperEl.clientWidth;
      var mainHeight = mainSwiperEl.clientHeight;
      var thumbsWidth = thumbsSwiperEl ? thumbsSwiperEl.clientWidth : 0;
      var thumbsHeight = thumbsSwiperEl ? thumbsSwiperEl.clientHeight : 0;
      if (mainSwiper && mainWidth) {
        if (force || mainSwiper.width !== mainWidth) mainSwiper.update();
        else if (mainSwiper.height !== mainHeight) mainSwiper.updateSize();
      }
      if (thumbsSwiper && thumbsWidth) {
        if (force || thumbsSwiper.width !== thumbsWidth) thumbsSwiper.update();
        else if (thumbsSwiper.height !== thumbsHeight) thumbsSwiper.updateSize();
      }
    }

    // Reuse the bundled Free Mode module: no extra library, images or clones.
    // Stop an in-flight coast before moving the same carousel into the lightbox.
    function readGalleryMotion() {
      if (!mainSwiper) return null;
      var enabled = window.innerWidth < 990 && !isModalOpen && mediaCount > 1;
      var momentum = !reducedMotion.matches;
      if (mainSwiper.params.freeMode.enabled === enabled &&
          mainSwiper.params.freeMode.momentum === momentum) return null;
      return mainSwiper.animating ? mainSwiper.getTranslate() : mainSwiper.translate;
    }

    function syncGalleryMotion(translate) {
      if (!mainSwiper) return;
      var enabled = window.innerWidth < 990 && !isModalOpen && mediaCount > 1;
      var momentum = !reducedMotion.matches;
      if (mainSwiper.params.freeMode.enabled !== enabled ||
          mainSwiper.params.freeMode.momentum !== momentum) {
        // The stored transform is authoritative while settled. Reading the
        // computed transform after photo/style writes forces a page layout.
        // A running momentum transition still needs its actual visual offset.
        if (typeof translate !== 'number') translate = readGalleryMotion();
        mainSwiper.setTransition(0);
        mainSwiper.setTranslate(translate);
        mainSwiper.animating = false;
        mainSwiper.params.freeMode.enabled = enabled;
        mainSwiper.params.freeMode.momentum = momentum;
        mainSwiper.originalParams.freeMode.enabled = enabled;
        mainSwiper.originalParams.freeMode.momentum = momentum;
        mainSwiperEl.classList.toggle('swiper-free-mode', enabled);
      }
      mainSwiper.params.speed = reducedMotion.matches ? 0 : 300;
      mainSwiper.originalParams.speed = mainSwiper.params.speed;
    }



    var inlinePhotoSizes = mainSwiperEl.querySelector('img.media-gallery__main')?.getAttribute('sizes') || '100vw';

    function syncGalleryPhotoSizes() {
      var sizes = isModalOpen ? '100vw' : inlinePhotoSizes;
      mainSwiperEl.querySelectorAll('img.media-gallery__main').forEach(function (image) {
        if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
      });
    }

    function loadGalleryPhoto(image) {
      var src = image.getAttribute('data-gallery-src');
      if (!src) return;
      var srcset = image.getAttribute('data-gallery-srcset');
      if (srcset) image.setAttribute('srcset', srcset);
      image.setAttribute('src', src);
      image.removeAttribute('data-gallery-srcset');
      image.removeAttribute('data-gallery-src');
    }

    function prepareGalleryPhotos(index, previous) {
      if (!mediaCount) return;
      var wanted = [index, (index + 1) % mediaCount];
      if (previous) wanted.push((index - 1 + mediaCount) % mediaCount);
      Array.from(mainWrapper.children).forEach(function (slide) {
        if (wanted.indexOf(Number(slide.dataset.galleryIndex)) === -1) return;
        slide.querySelectorAll('img[data-gallery-src]').forEach(loadGalleryPhoto);
      });
    }

    function activeGalleryIndex() {
      var active = mainSwiper && mainSwiper.slides[mainSwiper.activeIndex];
      return active ? Number(active.dataset.galleryIndex) : 0;
    }

    function showGalleryMedia(index, speed) {
      prepareGalleryPhotos(index);
      var target = index;
      if (bufferedGallery) {
        var distance = Infinity;
        mainSwiper.slides.forEach(function (slide, position) {
          if (Number(slide.dataset.galleryIndex) !== index) return;
          var delta = Math.abs(position - mainSwiper.activeIndex);
          if (delta < distance) {
            distance = delta;
            target = Number(slide.dataset.swiperSlideIndex);
          }
        });
      }
      if (mainSwiper.params.loop) mainSwiper.slideToLoop(target, speed);
      else mainSwiper.slideTo(target, speed);
    }

    function syncBufferedThumbs() {
      var active = mainSwiper.slides[mainSwiper.activeIndex];
      if (!active || !thumbsSwiper) return;
      var index = active.dataset.galleryIndex;
      thumbsSwiper.slides.forEach(function (thumb) {
        var selected = thumb.dataset.thumbIndex === index;
        if (thumb.classList.contains('swiper-slide-thumb-active') !== selected) {
          thumb.classList.toggle('swiper-slide-thumb-active', selected);
        }
        var current = selected ? 'true' : 'false';
        if (thumb.getAttribute('aria-current') !== current) thumb.setAttribute('aria-current', current);
      });
    }

    function openModal(idx) {
      if (isModalOpen) return;
      if (!modal.classList.contains('modal-open')) returnFocus = document.activeElement;
      var inlineHeight = window.innerWidth < 990 && mainSwiperEl.parentNode === inlineAnchor && !inlineReservation
        ? inlineAnchor.getBoundingClientRect().height : 0;
      isModalOpen = true;
      var motionTranslate = readGalleryMotion();
      reserveInlineGallerySpace(inlineHeight);
      syncGalleryMotion(motionTranslate);
      syncGalleryPhotoSizes();
      prepareGalleryPhotos(idx, true);
      scheduleModalChange(function () {
        moveNode(mainSwiperEl, modalAnchor, thumbsSwiperEl);
        // Measure the parked carousel before changing page-wide scroll styles.
        // The hidden lightbox retains its geometry through visibility: hidden.
        updateGalleryLayout(false);
        // Swiper.update already aligns the current photo after resizing.
        // Avoid a second loop-fix/layout pass when that photo is already aligned.
        var snap = mainSwiper.snapGrid[mainSwiper.snapIndex];
        var aligned = activeGalleryIndex() === idx && typeof snap === 'number' &&
          Math.abs(Math.abs(mainSwiper.translate) - snap) < 1;
        if (!aligned) showGalleryMedia(idx, 0);
        modal.classList.add('modal-open');
        if (!bodyLockApplied) {
          bodyOverflowY = document.body.style.getPropertyValue('overflow-y');
          bodyOverflowPriority = document.body.style.getPropertyPriority('overflow-y');
        }
        bodyLockApplied = true;
        document.body.style.setProperty('overflow-y', 'hidden', bodyOverflowPriority);
        restoreFocusAfterLayout(closeBtn, true);
      });
    }

    function closeModal() {
      if (!isModalOpen) return;
      isModalOpen = false;
      var motionTranslate = readGalleryMotion();
      syncGalleryMotion(motionTranslate);
      syncGalleryPhotoSizes();
      scheduleModalChange(function () {
        modal.classList.remove('modal-open');
        if (bodyLockApplied && document.body.style.getPropertyValue('overflow-y') === 'hidden' &&
            document.body.style.getPropertyPriority('overflow-y') === bodyOverflowPriority) {
          if (bodyOverflowY) document.body.style.setProperty('overflow-y', bodyOverflowY, bodyOverflowPriority);
          else document.body.style.removeProperty('overflow-y');
        }
        bodyLockApplied = false;
        if (window.innerWidth < 990) {
          moveNode(mainSwiperEl, inlineAnchor);
          updateGalleryLayout(false);
        }
        releaseInlineGallerySpace();
        restoreFocusAfterLayout(returnFocus, false);
      });
    }

    document.querySelectorAll('.media-gallery-grid-item').forEach(function (el) {
      function openFromGrid() {
        var raw = el.getAttribute('data-gallery-index');
        var idx = raw != null ? parseInt(raw, 10) : NaN;
        if (!isNaN(idx)) openModal(idx);
      }
      el.addEventListener('click', openFromGrid);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openFromGrid();
        }
      });
    });

    document
      .querySelectorAll('.media-gallery-main .swiper-slide img, .media-gallery-main .swiper-slide video')
      .forEach(function (el) {
        el.addEventListener('click', function () {
          if (mainSwiper && mainSwiper.allowClick === false) return;
          var slide = el.closest('.swiper-slide');
          if (!slide) return;
          var raw = slide.getAttribute('data-gallery-index');
          var idx = raw != null ? parseInt(raw, 10) : NaN;
          if (!isNaN(idx)) openModal(idx);
        });
      });

    var closeBtn = document.getElementById('media-gallery-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    modal.addEventListener('click', function (e) {
      if (!isModalOpen || e.defaultPrevented || mainSwiper.allowClick === false) return;
      if (e.target.closest('button, a, input, select, textarea, label, summary, [role="button"], [role="link"], [contenteditable="true"], .media-gallery-thumbs, img, video, iframe, model-viewer')) return;
      closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (isModalOpen && e.key === 'Escape') closeModal();
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        var focusableEls = modal.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
        var firstEl = focusableEls[0];
        var lastEl = focusableEls[focusableEls.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === firstEl) {
            lastEl.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastEl) {
            firstEl.focus();
            e.preventDefault();
          }
        }
      }
    });

    function getCenteredSlides() {
      return window.innerWidth >= 990 && mediaCount > 3;
    }

    function initSwipers() {
      thumbsSwiper = thumbsSwiperEl ? new Swiper(thumbsSwiperEl, {
        resizeObserver: false,
        updateOnWindowResize: false,
        slidesPerView: Math.min(6, mediaCount),
        spaceBetween: 8,
        watchSlidesProgress: true,
        slideToClickedSlide: false,
        loop: mediaCount > 6,
        // The main Swiper's thumbs module owns tap navigation. A second click
        // handler races its loop correction and can land on the wrong photo.
      }) : null;

      var mainOptions = {
        resizeObserver: false,
        updateOnWindowResize: false,
        slidesPerView: mediaCount > 1 ? 1.2 : 1,
        spaceBetween: 10,
        loop: mediaCount > 1,
        loopAdditionalSlides: Math.max(0, Math.min(2, Math.floor(carouselCount / 2) - 2)),
        centeredSlides: getCenteredSlides(),
        // Free release: a slow drag stays where released; a flick coasts.
        freeMode: {
          enabled: window.innerWidth < 990 && mediaCount > 1,
          sticky: false,
          momentum: !reducedMotion.matches,
          momentumBounce: false,
          momentumRatio: 1,
          momentumVelocityRatio: 1,
        },
        speed: reducedMotion.matches ? 0 : 300,
        zoom: true,
        thumbs: {
          swiper: bufferedGallery ? null : thumbsSwiper,
        },
        keyboard: {
          enabled: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous media',
          nextSlideMessage: 'Next media',
        },
      };

      if (enableNavigation) {
        mainOptions.navigation = {
          nextEl: '.media-gallery-main .swiper-button-next',
          prevEl: '.media-gallery-main .swiper-button-prev',
        };
      }

      mainSwiper = new Swiper('.media-gallery-main', mainOptions);
      // Keep distant mobile photos off the startup connection. Prime the
      // current/next photo on navigation and both directions on touch intent.
      mainSwiper.on('slideChange', function () { prepareGalleryPhotos(activeGalleryIndex()); });
      mainSwiper.on('touchStart', function () { prepareGalleryPhotos(activeGalleryIndex(), true); });
      root.addEventListener('click', function (event) {
        if (event.target.closest('.media-gallery-main .swiper-button-prev')) {
          prepareGalleryPhotos((activeGalleryIndex() - 1 + mediaCount) % mediaCount, true);
        }
      }, true);
      if (bufferedGallery) {
        mainSwiper.slides.forEach(function (slide) {
          slide.setAttribute('aria-label', (Number(slide.dataset.galleryIndex) + 1) + ' / ' + mediaCount);
        });
        if (thumbsSwiper) {
          function selectThumb(thumb) {
            if (thumb) showGalleryMedia(Number(thumb.dataset.thumbIndex), mainSwiper.params.speed);
          }
          thumbsSwiper.on('tap', function () { selectThumb(thumbsSwiper.clickedSlide); });
          thumbsSwiper.slides.forEach(function (thumb) {
            thumb.setAttribute('role', 'button');
            thumb.setAttribute('tabindex', '0');
            thumb.setAttribute('aria-label', 'View media ' + (Number(thumb.dataset.thumbIndex) + 1) + ' of ' + mediaCount);
            thumb.addEventListener('keydown', function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                selectThumb(thumb);
              }
            });
          });
          mainSwiper.on('slideChange update', syncBufferedThumbs);
          syncBufferedThumbs();
        }
      }
      // During a gesture, recycle slides without snapping to a slide edge.
      // Keep the drag origin in the same coordinate space after recycling,
      // including when a new touch interrupts an in-flight momentum transition.
      var fixLoop = mainSwiper.loopFix;
      mainSwiper.loopFix = function (options) {
        if (!this.params.freeMode.enabled) return fixLoop.call(this, options);
        options = Object.assign({}, options, { byMousewheel: true });
        var before = this.translate;
        var result = fixLoop.call(this, options);
        var shift = this.translate - before;
        if (options.setTranslate && shift) {
          this.touchEventsData.startTranslate += shift;
          this.touchEventsData.currentTranslate += shift;
        }
        this.updateActiveIndex();
        this.updateSlidesClasses();
        // Commit the compensated transform after DOM recycling before Free
        // Mode starts its next CSS transition. Without this flush the browser
        // can animate from the old physical offset and visibly skip a photo.
        if (shift) this.wrapperEl.getBoundingClientRect();
        return result;
      };

      // Recycle offscreen slides before calculating inertia, preserving the
      // fractional drag offset. Otherwise Free Mode hits its physical bound
      // after the first lap and later flicks stop without coasting.
      var releaseFreeMode = mainSwiper.freeMode.onTouchEnd;
      mainSwiper.freeMode.onTouchEnd = function (state) {
        if (mainSwiper.params.loop && mainSwiper.params.freeMode.enabled &&
            !mainSwiper.touchEventsData.isTouched && mainSwiper.swipeDirection) {
          mainSwiper.loopFix({ direction: mainSwiper.swipeDirection });
          state = { currentPos: mainSwiper.rtlTranslate ? mainSwiper.translate : -mainSwiper.translate };
        }
        releaseFreeMode(state);
      };
    }

    if (!mainSwiper || !thumbsSwiper) {
      initSwipers();
    }

    function handleResize() {
      var gridWrapper = document.getElementById('media-gallery-grid-wrapper');
      var swiperInline = document.getElementById('media-gallery-swiper-inline');
      var desktop = window.innerWidth >= 990;
      var motionTranslate = readGalleryMotion();
      if (gridWrapper && gridWrapper.classList.contains('hidden') !== !desktop) gridWrapper.classList.toggle('hidden', !desktop);
      if (swiperInline && swiperInline.classList.contains('hidden') !== desktop) swiperInline.classList.toggle('hidden', desktop);
      if (mainSwiper) {
        var centered = getCenteredSlides();
        if (!isModalOpen) {
          var desktop = window.innerWidth >= 990;
          moveNode(mainSwiperEl, desktop ? modalAnchor : inlineAnchor, desktop ? thumbsSwiperEl : null);
        }
        if (window.innerWidth >= 990) releaseInlineGallerySpace();
        var centeredChanged = mainSwiper.params.centeredSlides !== centered;
        mainSwiper.params.centeredSlides = centered;
        syncGalleryMotion(motionTranslate);
        updateGalleryLayout(centeredChanged);
      }
    }
    function scheduleGalleryResize() {
      if (resizeFrame) return;
      resizeFrame = requestAnimationFrame(function () {
        resizeFrame = 0;
        handleResize();
      });
    }
    window.addEventListener('resize', scheduleGalleryResize);
    if (typeof ResizeObserver === 'function') {
      var galleryResizeObserver = new ResizeObserver(scheduleGalleryResize);
      galleryResizeObserver.observe(mainSwiperEl);
      if (thumbsSwiperEl) galleryResizeObserver.observe(thumbsSwiperEl);
    }
    reducedMotion.addEventListener('change', function () { syncGalleryMotion(); });
    handleResize();
  });

  var showMoreBtn = document.getElementById('media-gallery-show-more');
  var grid = document.getElementById('media-gallery-grid');
  var fade = document.getElementById('media-gallery-fade');
  var collapsedMaxHeight = '900px';
  if (showMoreBtn && grid) {
    var expanded = false;
    showMoreBtn.addEventListener('click', function () {
      if (!expanded) {
        grid.style.maxHeight = 'none';
        showMoreBtn.textContent = 'Show Less';
        if (fade) fade.style.display = 'none';
        expanded = true;
      } else {
        grid.style.maxHeight = collapsedMaxHeight;
        showMoreBtn.textContent = 'Show More';
        if (fade) fade.style.display = '';
        expanded = false;
      }
    });
  }
})();






